
<iframe [style.height]="innerHeight" id="TransferReceiptsIframe" style="width: 100%;" [src]="transferReceiptsUrl | safe" title="Transfer Receipts"></iframe>
